
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/brands",
      function () {
        return require("private-next-pages/context-hub/brands.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/brands"])
      });
    }
  